export interface LaborBillingTemplate {
  billingClass: string;
  companyID: string;
  craft: string;
  description: string;
  earnTypeID: string;
  factor: number;
  jobClass: string;
  laborBillingTemplateID: number;
  rate: number;
  rateOpt: string;
  restrictByEarn: boolean;
  restrictByFactor: boolean;
  restrictByShift: boolean;
  shift: number;
  template: string;
}
